import { Tooltip, Space, Typography, Table } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { InvoiceItem } from "../../repository/data.default";
import { bankersRounding } from "../../utils/bankersRounding";

//Tooltip
function renderTooltip(title: "Unit Price" | "Net Price" | "Gross Price") {
  return (
    <Space className="flex justify-between">
      <Typography.Text>{title}</Typography.Text>
      <Tooltip
        title={title === "Gross Price" ? "Including V.A.T" : "Excluding V.A.T"}
      >
        <InfoCircleOutlined style={{ color: "#1890ff" }} />
      </Tooltip>
    </Space>
  );
}

//Table Columns
export const invoiceItemsViewColumns = [
  {
    title: "Description",
    dataIndex: "description",
  },
  {
    title: "Qty",
    dataIndex: "quantity",
  },
  {
    title: renderTooltip("Unit Price"),
    dataIndex: "unitPrice",
    render: (value: any) => `${Number(value).toFixed(2)} €`,
  },
  {
    title: renderTooltip("Net Price"),
    render: (_: any, record: InvoiceItem) => {
      const netPrice = bankersRounding(record.quantity * record.unitPrice);
      return `${netPrice.toFixed(2)} €`;
    },
  },
  {
    title: "V.A.T",
    dataIndex: "vatPercentage",
    render: (value: InvoiceItem) => `${Number(value)} %`,
  },
  {
    title: "V.A.T Amount",
    dataIndex: "vatAmount",
    render: (_: any, record: InvoiceItem) => {
      const netPrice = record.quantity * record.unitPrice;
      const vatAmount = bankersRounding(netPrice * record.vatPercentage) / 100;
      return `${vatAmount.toFixed(2)} €`;
    },
  },
  {
    title: renderTooltip("Gross Price"),
    render: (_: any, record: InvoiceItem) => {
      const netPrice = record.quantity * record.unitPrice;
      const vatAmount = (netPrice * record.vatPercentage) / 100;
      const grossPrice = bankersRounding(netPrice + vatAmount);
      return `${grossPrice.toFixed(2)} €`;
    },
  },
];

//Table Footer
export function TableFooter({ invoiceItems }: { invoiceItems: InvoiceItem[] }) {
  const totalNetPrice = invoiceItems.reduce(
    (sum, item) => sum + item.quantity * item.unitPrice,
    0,
  );

  const totalVatAmount = invoiceItems.reduce(
    (sum, item) =>
      sum + (item.quantity * item.unitPrice * item.vatPercentage) / 100,
    0,
  );

  const totalGrossPrice = totalNetPrice + totalVatAmount;

  const netPrice = bankersRounding(totalNetPrice);
  const vatAmount = bankersRounding(totalVatAmount);
  const grossPrice = bankersRounding(totalGrossPrice);

  return (
    <Table.Summary.Row style={{ backgroundColor: "#fafafa" }}>
      <Table.Summary.Cell index={0} colSpan={3}>
        <Typography.Text className="font-bold">Total</Typography.Text>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={1}>
        <Typography.Text className="font-bold">
          {netPrice.toFixed(2)} €
        </Typography.Text>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={2}></Table.Summary.Cell>
      <Table.Summary.Cell index={3}>
        <Typography.Text className="font-bold">
          {vatAmount.toFixed(2)} €
        </Typography.Text>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={4}>
        <Typography.Text className="font-bold">
          {grossPrice.toFixed(2)} €
        </Typography.Text>
      </Table.Summary.Cell>
    </Table.Summary.Row>
  );
}
